export default __webpack_public_path__ + "static/leadHero-3513a7ae1e6273e6a07c43795279d004.jpg";